import React, { useRef } from "react";
import {
  CustomText,
  Input,
  InputDate,
  SelectComponent,
} from "../../../components";
import { FormFull } from "form-full";
import { fonts } from "../../../config";

import { masks, validations } from "../../../utils";
import { StylesGuest } from "../styles";
import { FormHelperText, Grid } from "@material-ui/core";
import { Visibility } from "@material-ui/icons";
import { customModal } from "../../../components/modals/utils";
import WebcamModal from "./WebcamModal";
import { LabelView, MyLabel } from "../../guestHome/GuestHome";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import "../../../phone.css";

function TenantForm({ data, onSubmit }) {
  const [fileName, setFileName] = React.useState<any>({});
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const fileRef = useRef<any | null>(null);
  const [docType, setDocType] = React.useState<any>(
    data?.secondaryGuests?.cpf ? 1 : data?.secondaryGuests?.passport ? 2 : 1
  );
  const [formRef, setFormRef] = React.useState<any>(null);
  const phone = React.useRef<any>();
  function setPhone(value) {
    phone.current = value;
  }

  React.useEffect(() => {
    if (data.primaryGuest?.image) {
      setFileName({ base: "GuestImage.png" });
      fileRef.current = { base: data.primaryGuest?.image };
    }
    if (data?.primaryGuest?.phone) {
      setPhone(data?.primaryGuest?.phone);
    }
  }, [data]);

  const handleImageChange = () => {
    const savePhoto = (fileData: { src: string; name: string }) => {
      setFileName({ base: fileData.name });
      fileRef.current = { base: fileData?.src };
      formRef.submit();
    };
    customModal.setInfos(
      "Cadastro da Facial",
      [],
      null,
      null,
      <WebcamModal onSubmit={savePhoto} data={data.place.configurationParameters} userId={data.id}/>,
      false,
      false
    );
  };

  const openModalViewImg = () => {
    customModal.setInfos(
      fileName.base,
      [],
      {
        onClick: () => {
          customModal.close();
        },
        label: "Voltar",
      },
      null,
      <div
        style={{
          paddingInline: "20px",
        }}
      >
        <div
          style={{
            borderRadius: "5px",
            maxHeight: "80vh",
            maxWidth: "80vw",
            height: "100%",
            width: "400px",
            minHeight: "300px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",

            backgroundImage: `url(${fileRef.current.base})`,
          }}
        />
      </div>,
      false,
      false
    );
  };

  return (
    <>
      <FormFull
        formRef={setFormRef}
        onSubmit={(data: any) => {
          data.phone = phone.current;
          onSubmit({ ...data, ...fileRef });
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} lg={4} xl={5}>
            <StylesGuest.Container>
              <CustomText
                style={{ paddingBottom: "5px" }}
                fontSize={2.25}
                fontFamily={fonts.bold}
                textColor="#4D585A"
              >
                Dados do Inquilino
              </CustomText>
              <CustomText
                style={{ paddingBottom: "25px" }}
                fontSize={1.75}
                fontFamily={fonts.regular}
                textColor="#24272A"
              >
                Validação dos dados básicos do inquilino do imóvel:
              </CustomText>

              <Grid container spacing={1}>
                <Grid item xs={12} md={12} lg={12}>
                  <Input
                    validation={validations.isValidFullname}
                    required={"Campo Obrigatório"}
                    label="NOME COMPLETO"
                    name="name"
                    defaultValue={data?.primaryGuest?.name}
                  />
                </Grid>
                
                <Grid item xs={12} md={6} lg={6}>
                  <SelectComponent
                    required={"*Campo Obrigatório"}
                    name="docType"
                    label="TIPO DO DOCUMENTO"

                    defaultValue={
                      data?.primaryGuest?.document? 1: data?.primaryGuest?.passport? 2: docType
                    }
                    onBlurCustom={() => {
                      formRef?.testFieldError("documento", true);
                    }}
                    onChangeCustom={(v) => {
                      setDocType(v);

                      formRef?.clearValue("docValue", false);

                      if (v === 1) {
                        formRef?.setFieldValidation("docValue",validations.validateCPF);
                      } else {
                        formRef?.setFieldValidation("docValue", (value) => {
                          return null;
                        });
                      }
                    }}
                    options={[
                      { value: 1, label: "CPF" },
                      { value: 2, label: "Passaporte" }
                    ]}
                  />
                </Grid>
               
                <Grid item xs={12} md={6} lg={6}>
                  <Input
                    mask={docType === 1 ? masks.CPF : undefined}
                    name="docValue"
                    label={docType === 1 ? "CPF" : "Passaporte"}
                    required={"Campo Obrigatório"}
                    maskToSubmit={(e, ffHandler) => {
                      let type = ffHandler?.getValue("docType", false);

                      if (type === 1) {
                        return masks.removeNumberMask(e);
                      } else {
                        return e;
                      }
                    }}
                    defaultValue={
                      data?.primaryGuest?.document
                        ? data?.primaryGuest?.document
                        : data?.primaryGuest?.passport
                    }
                    validation={(e, ffHandler) => {
                      let type = ffHandler?.getValue("docType", false);

                      if (type === 1) {
                        return validations.validateCPF(e);
                      } else {
                        return undefined;
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <Input
                    validation={validations.isEmailValid}
                    required={"Campo Obrigatório"}
                    label="E-mail"
                    name="email"
                    defaultValue={data?.primaryGuest?.email}
                    readOnly={true}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <LabelView>
                    <MyLabel
                      className={
                        "form-input-label-" + "telefone"?.replace(/\s/g, "")
                      }
                    >
                      {"Telefone*"}
                    </MyLabel>
                  </LabelView>
                  <div
                    style={{
                      backgroundColor: "#E9E9E9",
                      height: "48px",
                      alignContent: "center",
                      border: "0px",
                      borderRadius: "5px",
                      padding: "5px",
                    }}
                  >
                    <PhoneInputWithCountrySelect
                      placeholder="TELEFONE"
                      numberInputProps={{
                        className: "focus:outline-none focus:ring-0",
                      }}
                      value={phone.current}
                      onChange={setPhone}
                    />
                  </div>
                  <div style={{ paddingBottom: "25px" }}></div>
                  {/*
                  <Input
                    mask={masks.inputMaskTELWithDDD}
                    readOnly={step > 1 ? true : false}
                    required={"Campo Obrigatório"}
                    label="TELEFONE"
                    name="phone"
                    defaultValue={data?.primaryGuest?.phone}
                    maskToSubmit={masks.removeNumberMask}
                  />*/}
                </Grid>
                {
                  <Grid item xs={12} md={12} lg={12}>
                    <CustomText
                      fontSize={1.75}
                      fontFamily={fonts.semibold}
                      textColor="#4D585A"
                    >
                      CADASTRO DA FACIAL*
                    </CustomText>
                    <StylesGuest.InputImage
                      style={{
                        backgroundColor: "#D39899",
                        borderColor: "red",
                        borderStyle: "solid",
                        borderWidth: "2px",
                      }}
                    >
                      <StylesGuest.InputImageClick htmlFor={"fileInput"}>
                        {fileName?.base ? (
                          <CustomText
                            style={{
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              display: "block",
                            }}
                            textColor="#4D585A"
                            fontSize={2}
                            fontFamily={fonts.medium}
                          >
                            {fileName?.base}
                          </CustomText>
                        ) : (
                          <CustomText
                            textColor="#4D585A"
                            fontSize={2}
                            fontFamily={fonts.medium}
                          >
                            Clique aqui para cadastrar sua facial
                          </CustomText>
                        )}

                        <button
                          id="fileInput"
                          onClick={() => handleImageChange()}
                          style={{ display: "none" }}
                        ></button>
                      </StylesGuest.InputImageClick>
                      {fileName?.base && (
                        <StylesGuest.InputView
                          endIcon={<Visibility />}
                          fullWidth={false}
                          onClick={() => openModalViewImg()}
                        >
                          Visualizar
                        </StylesGuest.InputView>
                      )}{" "}
                    </StylesGuest.InputImage>{" "}
                    <FormHelperText
                      style={{ color: "#24272A" }}
                      error={false}
                    ></FormHelperText>
                  </Grid>
                }
                <StylesGuest.ButtonsContainer>
                  <StylesGuest.SendForm
                    disabled={Object.keys(fileName).length < 1}
                    fullWidth={false}
                    action="submit"
                    style={
                      Object.keys(fileName).length >= 1
                        ? {
                            backgroundColor: "red",
                            borderColor: "red",
                            borderStyle: "solid",
                            borderWidth: "2px",
                          }
                        : {}
                    }
                  >
                    Confirmar dados
                  </StylesGuest.SendForm>
                </StylesGuest.ButtonsContainer>
              </Grid>
            </StylesGuest.Container>
          </Grid>
        </Grid>
      </FormFull>
    </>
  );
}

export default TenantForm;
